<template>
  <div>
    <h2 class="sec-title">{{ c.add_title }}</h2>
    <v-card variant="flat" class="intro-card mb-4">
      <v-card-text>
        <p class="mb-3">{{ c.add_intro }}</p>
        <v-btn color="primary" variant="flat" @click="showAdd = true">
          <v-icon start>mdi-plus</v-icon>{{ c.add_btn }}
        </v-btn>
      </v-card-text>
    </v-card>

    <h3 class="list-title">{{ c.add_my_list }}</h3>
    <div v-if="loading" class="text-center py-6 text-medium-emphasis">{{ c.loading }}</div>
    <div v-else-if="!items.length" class="empty">{{ c.add_empty }}</div>
    <v-list v-else class="rounded-lg" border>
      <v-list-item v-for="(n, i) in items" :key="i">
        <template v-slot:prepend><v-icon color="primary">mdi-phone</v-icon></template>
        <v-list-item-title class="font-weight-bold">{{ n.msisdn }}</v-list-item-title>
        <v-list-item-subtitle>{{ n.mvno_name }} · {{ n.verified ? '✅' : '⏳' }}</v-list-item-subtitle>
        <template v-slot:append>
          <v-btn size="small" color="secondary" variant="tonal" @click="openPort(n)">
            <v-icon start size="small">mdi-swap-horizontal</v-icon>{{ c.request_port }}
          </v-btn>
        </template>
      </v-list-item>
    </v-list>

    <AddUserMsisdnDialog v-if="showAdd" @close="showAdd = false" @msisdnAdded="onAdded" />
    <CreatePortabilityRequestDialog
      v-if="showPort"
      :token="token"
      :msisdn="selected"
      @close="showPort = false"
      @created="onPortCreated"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { cc } from "@/views/client/clientCopy";
import { getToken } from "@/composables/useTokenStorage";
import { getUserOwnMsisdns } from "@/composables/useUserMsisdnsAPI";
import AddUserMsisdnDialog from "@/components/AddUserMsisdnDialog.vue";
import CreatePortabilityRequestDialog from "@/components/CreatePortabilityRequestDialog.vue";

export default defineComponent({
  name: 'AddNumberSection',
  components: { AddUserMsisdnDialog, CreatePortabilityRequestDialog },
  data() { return { loading: true, items: [], showAdd: false, showPort: false, selected: null, token: getToken() }; },
  computed: { c() { return cc(); } },
  async created() { await this.load(); },
  methods: {
    async load() {
      this.loading = true;
      const resp = await getUserOwnMsisdns(getToken());
      this.items = (resp && resp.msisdns) || [];
      this.loading = false;
    },
    onAdded() { this.showAdd = false; this.load(); },
    openPort(n) { this.selected = n; this.showPort = true; },
    onPortCreated() { this.showPort = false; this.load(); },
  },
});
</script>

<style scoped>
.sec-title { font-size: 1.4rem; font-weight: 800; color: #1a2233; margin-bottom: 16px; }
.intro-card { border: 1px solid #E6E9F0; border-radius: 16px; }
.list-title { font-weight: 700; color: #1a2233; margin-bottom: 10px; }
.empty { text-align: center; color: #5A6275; padding: 24px 0; }
</style>
